import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FormattedMessage, FormattedHTMLMessage, useIntl } from "react-intl";

import { getPaypalCode } from "../../../../common/parameters";
import routing from "../../../routing";

import { amazonHost } from "../../../paths";

import Icon from "../../../icon";

import { StyledWhy, P, Row, Column, IconWrapper, Description, DonateButton } from "./styles";
import messages from "./messages";

const dev = process.env.NODE_ENV;

const Why = ({ isNativeApp = false }) => {
    const { locale } = useIntl();
    const [isLoading, setLoading] = useState(false);
    return (
        <StyledWhy
            style={{
                backgroundImage: `url('images/polygon_back.svg')`,
            }}
        >
            <h2>
                <FormattedMessage {...messages.h2} />
            </h2>
            <P>
                <FormattedHTMLMessage {...messages.p} />
            </P>
            <Row>
                <Column>
                    <IconWrapper>
                        <Icon i="share" />
                    </IconWrapper>
                    <Description>
                        <FormattedMessage {...messages.share} />
                    </Description>
                </Column>
                <Column style={{
                    ...(isNativeApp && {
                        pointerEvents: "none"
                    })
                }}>
                    <Link to={`/${routing.translate}`}>
                        <IconWrapper>
                            <Icon i="translate" />
                        </IconWrapper>
                        <Description>
                            <FormattedMessage {...messages.translate} />
                        </Description>
                    </Link>
                </Column>
                <Column>
                    <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                        <input type="hidden" name="cmd" value="_s-xclick" />
                        <input type="hidden" name="hosted_button_id" value={getPaypalCode(locale)} />
                        <DonateButton
                            type="submit"
                            name="submit"
                            title="PayPal - The safer, easier way to pay online!"
                            onClick={() => {
                                setLoading(true);
                            }}
                            style={{
                                cursor: isLoading ? "progress" : "pointer",
                            }}
                        >
                            <IconWrapper>
                                <Icon i="donate" />
                            </IconWrapper>
                            <Description>
                                <FormattedMessage {...messages.donate} />
                            </Description>
                        </DonateButton>
                    </form>
                </Column>
            </Row>
        </StyledWhy>
    );
};

export default Why;
